module.exports = __webpack_public_path__ + "img/falsesymmetry-3205062f-0582-4029-489a-08d95b7e528f.png";